// extracted by mini-css-extract-plugin
module.exports = {"SearchResultsCount":"SearchResultsCount_SearchResultsCount__1YGjz","Active":"SearchResultsCount_Active__2mcGs"};